import { Component } from '@angular/core';

/** Component for showing metadata about the plot data */
@Component({
    selector: 'sci-annotations-bar',
    template: `
        <mat-toolbar>
            <sci-zoom-tools></sci-zoom-tools>
            <sci-select-tools></sci-select-tools>
            <sci-drawing-tools></sci-drawing-tools>
            <div class="toolbar-separator">&nbsp;</div>
            <sci-color-tools></sci-color-tools>
            <sci-line-tools></sci-line-tools>
            <div class="toolbar-separator">&nbsp;</div>
            <sci-undo-annotations></sci-undo-annotations>
            <sci-undo-zoom></sci-undo-zoom>
        </mat-toolbar>
        <mat-divider></mat-divider>
    `,
    styleUrls: [ './annotations.component.scss' ]
})
export class AnnotationsBarComponent  {}
